/**
 * Job Queue Configuration
 *
 * durationPredicted is not stored on frontend.
 * Backend sends durationPredicted for each job based on:
 * - User subscription plan (speed multiplier)
 * - Job type (render/album/upscale/control)
 * - Provider availability
 * - Current system load
 */

export const JOB_QUEUE_CONFIG = {
  /**
   * Progress update interval
   * How often to recalculate time-based progress for active jobs
   */
  PROGRESS_UPDATE_INTERVAL: 1000, // 1 second

  /**
   * Cleanup thresholds for renders Map
   * Backend manages cleanup of jobQueue (keeps last 5-10 min)
   * Frontend only needs to clean up old full Render objects from renders Map
   */
  CLEANUP: {
    /** Maximum number of completed renders to keep in memory */
    MAX_COMPLETED_RENDERS: 100,
    /** Age threshold - renders older than this are removed */
    MAX_AGE_MS: 30 * 60 * 1000, // 30 minutes
  },

  /**
   * Maximum queue size from API
   * How many jobs to fetch from backend
   */
  DEFAULT_QUEUE_LIMIT: 5,
  MAX_QUEUE_LIMIT: 50,

  /**
   * Progress calculation thresholds
   */
  PROGRESS: {
    /** After this percentage, progress slows down logarithmically */
    SLOWDOWN_THRESHOLD: 90,
    /** Maximum progress before actual completion */
    MAX_PREDICTED_PROGRESS: 95,
  },
} as const;

export type JobQueueConfig = typeof JOB_QUEUE_CONFIG;
